module.exports = __webpack_public_path__ + "static/media/zo-goed-als-oud-online-shop-for-vintage-furniture-lighting-and-accessories.2cb573c4.svg";